import React from 'react';
import styles from "./Checkbox.module.scss";
import ErrorText from '../ErrorText/ErrorText';

const Checkbox = ({ className, error, label, formik, name, ...rest }) => {
	return (
		<>
			<div className={`${styles.checkbox} ${className || ""}`}>
				<div className={styles.checkbox_inner}>
					<input
						{...rest}
						className="form-check-input"
						type="checkbox"
						name={name}
						// id={name}
					/>
				</div>
				<label htmlFor={name}>{label}</label>
			</div>
			{error && <ErrorText>{error}</ErrorText>}
		</>
	)
}

export default Checkbox